import { changeStyle, formatYearDate } from "../../utils/format";
import {
  ColumnLayout,
  Box,
  SpaceBetween,
  Container,
  Badge,
  Header,
  TextContent,
  Grid,
  Button,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";
import {
  getAddressLabel,
  getContractStyleLabel,
  getMerchantAddressDetailButtonLabel,
} from "./util";
import { MerchantInfoResponse } from "../../features/api-interfaces";
import { useState } from "react";
import { useCanIShowHook } from "../../app/useCanIShowHook";
import { USER_TYPE } from "../../configs/constants";
import { AddressInfoDetailModal } from "./address-info-modal/ApplicationCompanyInfoModal";

interface ICorpInfoForm {
  corpInfo: MerchantInfoResponse;
  hasCreatedBy: string;
  hasCreatedAt: string;
}

const CorpInfoForm = (props: ICorpInfoForm) => {
  const { corpInfo, hasCreatedBy, hasCreatedAt } = props;
  const [visible, setVisible] = useState(false);
  // ユーザ権限
  const isDocomoUser = useCanIShowHook(USER_TYPE.DOCOMO);

  return (
    <Container
      header={
        <ColumnLayout columns={2}>
          <Header variant="h2">{LABELS.FORM_TITLE}</Header>
          {/* TODO: 最終更新者最終更新日 実装するか未定 */}
          {hasCreatedBy && (
            <Box float={"right"}>
              <Badge color={"green"}>
                {LABELS.LAST_UPDATER}
                {hasCreatedBy}/{LABELS.LAST_UPDATING_TIME}
                {formatYearDate(hasCreatedAt)}
              </Badge>
            </Box>
          )}
        </ColumnLayout>
      }
    >
      <SpaceBetween direction="vertical" size="xxs">
        <Grid gridDefinition={[{ colspan: 1 }, { colspan: 11 }]}>
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              <h4>{LABELS.CONTRACT_STYLE}</h4>
            </TextContent>
          </SpaceBetween>
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              <p>{getContractStyleLabel(corpInfo.contractStyles)}</p>
            </TextContent>
          </SpaceBetween>
        </Grid>
        <Grid
          gridDefinition={[
            { colspan: 1 },
            { colspan: 4 },
            { colspan: 1 },
            { colspan: 6 },
          ]}
        >
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              <h4>{LABELS.CORP_NAME}</h4>
            </TextContent>
          </SpaceBetween>
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              <p>{corpInfo.companyName}</p>
            </TextContent>
          </SpaceBetween>
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              <h4>{LABELS.CORPORATE_NUMBER}</h4>
            </TextContent>
          </SpaceBetween>
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              <p>{corpInfo.corporateNumber ?? LABELS.BLANK_SPACE_ONE}</p>
            </TextContent>
          </SpaceBetween>
        </Grid>

        <Grid
          gridDefinition={[
            { colspan: 1 },
            { colspan: 4 },
            { colspan: 1 },
            { colspan: 6 },
          ]}
        >
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              <h4>{LABELS.CORP_KANA}</h4>
            </TextContent>
          </SpaceBetween>
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              <p>{corpInfo.companyNameKana}</p>
            </TextContent>
          </SpaceBetween>
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              <h4>{LABELS.CORP_ENG}</h4>
            </TextContent>
          </SpaceBetween>
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              <p>
                {corpInfo.companyNameAlphabetical ?? LABELS.BLANK_SPACE_ONE}
              </p>
            </TextContent>
          </SpaceBetween>
        </Grid>

        <Grid gridDefinition={[{ colspan: 1 }, { colspan: 4 }, { colspan: 7 }]}>
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              <h4>{LABELS.ADDRESS}</h4>
            </TextContent>
          </SpaceBetween>
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              {corpInfo.addressList && corpInfo.addressList.length > 0 ? (
                [...corpInfo.addressList]
                  .sort((a, b) => a.addressType - b.addressType)
                  .map((cor) => (
                    <p key={cor.addressType}>
                      {getAddressLabel(cor.addressType) +
                        (cor.postalCode
                          ? changeStyle(cor.postalCode ?? "")
                          : LABELS.BLANK_SPACE_ONE) +
                        LABELS.BLANK_SPACE_ONE +
                        (cor.address1 ?? "") +
                        (cor.address2 ?? "")}
                    </p>
                  ))
                  .slice(0, LABELS.ADDRESS_SHOW_LEN)
              ) : (
                <></>
              )}
            </TextContent>
          </SpaceBetween>
          {isDocomoUser ? (
            <Button
              disabled={
                corpInfo.addressList === undefined ||
                corpInfo.addressList.length <= 0
              }
              onClick={() => setVisible(true)}
            >
              {getMerchantAddressDetailButtonLabel(corpInfo.addressList)}
            </Button>
          ) : (
            <></>
          )}
        </Grid>
        <Grid gridDefinition={[{ colspan: 1 }, { colspan: 11 }]}>
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              <h4>{LABELS.TEL}</h4>
            </TextContent>
          </SpaceBetween>
          <SpaceBetween direction="vertical" size="xxs">
            <TextContent>
              <p>{corpInfo.phoneNumber}</p>
            </TextContent>
          </SpaceBetween>
        </Grid>
      </SpaceBetween>
      <AddressInfoDetailModal
        visible={visible}
        setVisible={setVisible}
        addressList={corpInfo.addressList}
      />
    </Container>
  );
};
export default CorpInfoForm;
